import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const QuickSearchResult = ({ result, selectedItem, searchUrl, totalResults }) => {

    const resultTransformer = (result) => {
        const typeGroups = {};

        result.forEach((item) => {
            const type = item.category;

            if (!typeGroups[type]) {
                typeGroups[type] = {
                    type,
                    list: []
                };
            }

            typeGroups[type].list.push(item);
        });

        const transformedResult = Object.values(typeGroups);
        return transformedResult;
    };


    const list = resultTransformer(result);

    return (
        <div className="quick-search-result">
            <div className="quick-search-result__inner">
                {list?.map((item, index) => {
                    switch (item.type) {
                        case 'Products':
                        case 'Categories':
                            return (
                                <section
                                    aria-label={item.type}
                                    key={`result-${index}`}
                                    className='quick-search-result__section'
                                >
                                    <QuickSearchProductsCategories
                                        type={item.type}
                                        list={item.list}
                                        selectedItem={selectedItem}
                                        index={index}
                                        totalResults={totalResults}
                                    />
                                </section>
                            );

                        default:
                            return null;
                    }
                })}
            </div>

            {list?.map((item, index) => {
                switch (item.type) {
                    case 'ShowAll':
                        return (
                            <div key={`result-${index}`} className="quick-search-result__show-all">
                                <a className="button-cta" href={searchUrl}>
                                    <span>{item.list[0].name}</span>
                                </a>
                            </div>
                        );

                    case 'NoHit':
                        return (
                            <Fragment key={`result-${index}`}>
                                <p className="quick-search-result__no-hit">{item.list[0].name}</p>
                            </Fragment>
                        );

                    default:
                        return null;
                }
            })}
        </div>
    );
};

export default QuickSearchResult;

function QuickSearchProductsCategories({ type, list, selectedItem, index, totalResults }) {
    // Variable to set the class name prefix based on the type
    const classNamePrefix = type.toLowerCase();

    const formatItemCountText = () => {
        const maxItemsPerType = 5;

        if (list?.length < maxItemsPerType) {
            return `${translate('code.search.itemcount.showing')} ${list.length} ${translate('code.search.itemcount.showing.total')} ${totalResults[type]}`;
        } else {
            return `${translate('code.search.itemcount.showing')} ${maxItemsPerType} ${translate('code.search.itemcount.showing.total')} ${totalResults[type]}`;
        }
    }

    return (
        <>
            <div className="quick-search-result__header">
                <h3 className="quick-search-result__title">{type}</h3>
                <span className="quick-search-result__count">
                    {/* Formating translation string with list items of total list length */}
                    {formatItemCountText(list.length)}
                </span>
            </div>
            <ul className={`quick-search-result__list ${classNamePrefix}`}>
                {list.map((item, i) => (
                    <li
                        key={`product-${i}`}
                        className={`quick-search-result__item ${selectedItem && selectedItem === index && type === "Products" ? 'quick-search-result__item--selected' : ''
                            }`}
                    >
                        <a
                            className={`quick-search-result__link ${classNamePrefix}`}
                            href={item.url}
                        >
                            {item.name}
                        </a>
                    </li>
                ))}
            </ul>
        </>
    )
}
